import { render } from "./Footer.vue?vue&type=template&id=19db84be"
import script from "./Footer.vue?vue&type=script&lang=js"
export * from "./Footer.vue?vue&type=script&lang=js"

import "./Footer.vue?vue&type=style&index=0&id=19db84be&lang=scss"

import exportComponent from "/var/www/basic/vue-about-us/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__